import { getBrand } from '../lib/brand'

type Variant = 'default' | 'transparent'

type LogoProps = {
  variant?: Variant
  className?: string
}

export function Logo({ variant = 'default', className = 'h-10 sm:h-12' }: LogoProps) {
  const brand = getBrand()
  // White-label: use the tenant's logo (GET /api/brand → logo_url) when set,
  // otherwise fall back to the bundled Minbesiktning logo.
  const fallback = variant === 'transparent' ? '/logo-transparent.svg' : '/logo.svg'
  const src = brand.logo_url || fallback

  return (
    <img
      src={src}
      alt={brand.app_name || 'Besiktning'}
      width={150}
      height={60}
      className={`w-auto ${className}`}
    />
  )
}
